module.exports = __webpack_public_path__ + "img/list_tm.9accf048.jpg";